import { DataDefinition } from "../Data/DataDefinition";
import { BaseExecutable } from "./BaseExecutable";
import { ExecutionData } from "../Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../Testing/ITestingContext";
import type { AppGlueAny } from "../AppGlueAny";

export abstract class Executable extends BaseExecutable {
    protected _executionResult?: (() => DataDefinition) | DataDefinition;

    get executionResult() {
        return this._executionResult;
    }

    set executionResult(res: (() => DataDefinition) | DataDefinition | undefined) {
        this._executionResult = res;
    }

    get canChangeOutputs(): boolean {
        return !this.executionResult || !(this.executionResult instanceof Function);
    }

    abstract run(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny;

    getExecutionResult(): DataDefinition {
        if (!this._executionResult) {
            this._executionResult = new DataDefinition();
            return this._executionResult;
        }

        if (this._executionResult instanceof Function) {
            return this._executionResult();
        } else {
            return this._executionResult;
        }
    }

    getStorageData(): object {
        let data = super.getStorageData();

        if (this._executionResult && !(this._executionResult instanceof Function)) {
            Reflect.set(data, "executionResult", this.getExecutionResult().getStorageData());
        }

        return data;
    }

    setStorageData(data: object) {
        super.setStorageData(data);

        let resultData = Reflect.get(data, "executionResult");

        if (resultData) {
            this._executionResult = new DataDefinition();
            this._executionResult.setStorageData(resultData);
        }
    }
}
